import React, { useEffect } from "react";

import { notify } from "../../../../services/toast.config";

interface EmbedCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  shareableUrl: string;
}

const EmbedCodeModal: React.FC<EmbedCodeModalProps> = ({
  isOpen,
  onClose,
  shareableUrl,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Generate the Iframe code
  const iframeCode = `<iframe src="${shareableUrl}" width="100%" height="800px" frameborder="0" allowfullscreen></iframe>`;

  const handleCopyCode = () => {
    navigator.clipboard.writeText(iframeCode);
    notify.success("Embed code copied to clipboard!");
  };

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Link Website / Embed Code</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="alert alert-light border-info" role="alert">
                <h6 className="alert-heading fw-bold mb-2">Instructions:</h6>
                <p className="mb-0 fs-14">
                  To display this form directly on your website, copy the code
                  below and paste it into the HTML of your web page where you
                  want the form to appear.
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium">Iframe Code</label>
                <div className="position-relative">
                  <textarea
                    className="form-control bg-light"
                    rows={4}
                    readOnly
                    value={iframeCode}
                    style={{
                      resize: "none",
                      fontFamily: "monospace",
                      fontSize: "12px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-light" onClick={onClose}>
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCopyCode}>
                <i className="ti ti-copy me-1" />
                Copy Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmbedCodeModal;
